@if (visible) {
<div class="alert" [attr.role]="type === 'danger' || type === 'warning' ? 'alert' : 'status'"
  [attr.aria-live]="type === 'danger' || type === 'warning' ? 'assertive' : 'polite'" aria-atomic="true" [ngClass]="[
      'alert-' + type,
      dismissible ? 'alert-dismissible' : '',
      extraClass
    ]">

  @if (icon) {
  <i [class]="'fa fa-' + icon" aria-hidden="true"></i>&nbsp;
  }

  <ng-content></ng-content>
  @if (dismissible) {
  <button type="button" class="close" [attr.aria-label]="'Common.Close' | translate" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
  }
</div>
}